import http from './http'
import type { UserMaterial, UserMaterialPayload } from '@/types/api'

export const materialService = {
  async list(): Promise<UserMaterial[]> {
    const { data } = await http.get<UserMaterial[]>('/user/materials')
    return data
  },

  async save(payload: UserMaterialPayload): Promise<UserMaterial> {
    const { data } = await http.post<UserMaterial>('/user/materials', payload)
    return data
  },

  async remove(id: string): Promise<void> {
    await http.delete(`/user/materials/${id}`)
  },
}
